import { useMemo } from 'react'

/**
 * useActivityAnswerFetchGate
 * Canonical gating logic for deciding whether to fetch an answer group.
 * Updated to match current provider behavior (exclude state.activityGroupAnswerId while in input mode
 * unless a valid parsed route answer id exists). Includes `signedIn` requirement.
 * Returns `enabled` plus a human readable `reason` useful for logging or devtools.
 */
export default function useActivityAnswerFetchGate({ state, infoDataType, parsedAnswerId, signedIn }) {
  return useMemo(() => {
    const hasParsedId = typeof parsedAnswerId === 'number' && !Number.isNaN(parsedAnswerId)

    const enabled = Boolean(
      signedIn && state?.isActivityGroupOpen && !infoDataType && (state?.activityGroupMode !== 'input' || hasParsedId)
    )

    let reason = 'disabled'
    if (enabled) reason = 'enabled'
    else if (!signedIn) reason = 'user not signed in'
    else if (!state?.isActivityGroupOpen) reason = 'activity group closed'
    else if (infoDataType) reason = 'informational group (infoDataType)'
    else if (state?.activityGroupMode === 'input' && !hasParsedId) reason = 'input mode without route answer id'

    return { enabled, reason, hasParsedId }
  }, [signedIn, state?.isActivityGroupOpen, state?.activityGroupMode, infoDataType, parsedAnswerId])
}
